"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _methods = require("../../../utils/methods");

var _style = require("./style");

var _index = _interopRequireDefault(require("../Tooltip/index"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Events = function Events(_ref) {
  var begin = _ref.begin,
      days = _ref.days,
      event = _ref.event;
  var data = (0, _methods.getDateTime)(begin, 'DAY', days);
  var items = [];
  var events = [];
  event.map(function (value) {
    return events.push(value.showAt);
  });

  for (var i = 0; i < days; i++) {
    for (var j = 0; j < events.length; j++) {
      if ((0, _moment["default"])(data[i]).format('YYYY-MM-DD') === (0, _moment["default"])(events[j]).format('YYYY-MM-DD')) {
        items.push( /*#__PURE__*/_react["default"].createElement(_style.Box, {
          style: {
            width: "".concat(100 / days, "%")
          }
        }, /*#__PURE__*/_react["default"].createElement(_index["default"], null)));
        break;
      } else if (j === events.length - 1 && (0, _moment["default"])(data[i]).format('YYYY-MM-DD') !== (0, _moment["default"])(events[j]).format('YYYY-MM-DD')) {
        items.push( /*#__PURE__*/_react["default"].createElement(_style.Box, {
          style: {
            width: "".concat(100 / days, "%")
          }
        }));
      }
    }
  }

  return /*#__PURE__*/_react["default"].createElement(_style.Container, null, items);
};

var _default = Events;
exports["default"] = _default;